import React from "react"
const PageContainer = ({ children, inIframe = false }) => {
  const cls = inIframe
    ? "mt a-episode-page col-12 mx-auto"
    : "px1 lg-px0 mt a-episode-page col-12 sm-col-10 md-col-9 mx-auto"

  return (
    <div className={cls}>
      <div className="bg-white t-pt3 t-pb6 t-ph2 t-ph3-m open-sans">
        {children}
      </div>
    </div>
  )
}

export default PageContainer
